// Click-to-enlarge for the gallery photos (Gallery page grid and Home's three).
document.addEventListener('DOMContentLoaded', function () {
  var imgs = document.querySelectorAll('[id$="__grid"] img, [id$="__featured"] img');
  if (!imgs.length) return;
  var overlay = document.createElement('div');
  overlay.className = 'rma-lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Enlarged photo');
  overlay.innerHTML = '<button type="button" class="rma-lightbox__close" aria-label="Close">×</button><img alt="">';
  document.body.appendChild(overlay);
  var big = overlay.querySelector('img');
  function close() { overlay.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  imgs.forEach(function (img) {
    img.style.cursor = 'zoom-in';
    img.setAttribute('tabindex', '0');
    function open(e) {
      e.preventDefault();
      var u = new URL(img.currentSrc || img.src, location.href);
      u.searchParams.set('width', '2000');
      big.src = u.toString();
      big.alt = img.alt || '';
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    img.addEventListener('click', open);
    img.addEventListener('keydown', function (e) { if (e.key === 'Enter') open(e); });
  });
});
